<template>
    <div class="page-layout blank contacts-manage">
        <!-- <div class="d-flex align-items-center justify-content-center mt-40" v-if="ajaxCallInProgress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div> -->
        <div class="pb-10 pr-3 pl-3">
            <!-- Breadcrumb section -->
            <div class="row">
                <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                    <div class="breadcrumbnew">
                        <span>Dashboard</span>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                </div>
            </div>
            <!-- Counts section -->
            <div class="row pt-1">
                <div class="col-12 col-sm-6 col-xl-3 pl-3 pr-3 pb-3 pointer">
                    <fullscreen class="box-radius bg-white" ref="report" @change="dataChange('report')" >
                        <div class="widget widget2 counts div-height bg-white text-auto" >
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 fs-16">Call Reports</div>
                                <!-- <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('report')">
                                    <img class="expand-img" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/expand_logo.svg" alt />
                                </button> -->
                            </div>
                            <div class="row" @click="$router.push('/callreportDashboard')">
                                <div class="col-lg-9 col-sm-9 col-9 pl-12 pt-6">
                                    <div class="w-100" v-if="ajaxCallreport && !callreport_count.count">
                                        <div colspan="15">
                                            <div class="d-flex align-items-center justify-content-center w-100">
                                                <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" style="margin: 0 auto;" />
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="callreport_count.count != 0 ">
                                        <h1 class="ml-3 text-new-violet">{{callreport_count.count}}</h1>
                                    </div>
                                    <div v-else class="fw-500 text-center"> <img class="data-image" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/call_report_logo.svg"></div>
                                </div>
                                <div v-if="callreport_count.count != 0" class="col-lg-3 col-sm-3 col-3 mt-20">
                                    <img class="logo-image" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/call_report_logo.svg">
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
                <div class="col-12 col-sm-6 col-xl-3 pl-3 pr-3 pb-3 pointer">
                    <fullscreen class="box-radius bg-white" ref="contacts" @change="dataChange('contacts')" >
                        <div class="widget widget2 counts div-height bg-white text-auto" >
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 fs-16">Business Contacts</div>
                                <!-- <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('contacts')">
                                    <img class="expand-img" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/expand_logo.svg" alt />
                                </button> -->
                            </div>
                            <div class="row h-25" @click="$router.push('/contactsDashboard')">
                                <div class="col-lg-9 col-sm-9 col-9 pl-12 pt-6">
                                    <div class="w-100" v-if="ajaxBusiness_and_survey && !busines_count">
                                        <div colspan="15">
                                            <div class="d-flex align-items-center justify-content-center w-100">
                                                <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" style="margin: 0 auto;" />
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="busines_count != 0">
                                        <h1 class="ml-3 text-new-violet">{{busines_count}}</h1>
                                    </div>
                                    <div v-else-if="busines_count == 0 && !ajaxBusiness_and_survey" class="fw-500 text-center"><img class="data-buiness-image" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/business_contact_logo.svg"></div>
                                </div>
                                <div v-if="busines_count != 0 || ajaxBusiness_and_survey" class="col-lg-3 col-sm-3 col-3 mt-20">
                                    <img class="logo-image" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/business_contact_logo.svg">
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
                <div class="col-12 col-sm-6 col-xl-3 pl-3 pr-3 pb-3">
                    <fullscreen  class="box-radius bg-white" ref="contracts" @change="dataChange('contracts')" >
                        <div class="widget widget2 counts bg-white text-auto pb-10px div-height"  >
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 fs-16">Contracts</div>
                                <!-- <button type="button" class="bg-white icon-outline-css" >
                                    <img class="expand-img" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/expand_logo.svg" alt />
                                </button> -->
                                <!--<button type="button" class="pointer bg-white icon-outline-css" @click="expandData('contracts')">
                                    <img class="expand-img" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/expand_logo.svg" alt />
                                </button>-->
                            </div>
                            <div class="row">
                                <div class="col-lg-9 col-sm-9 col-9 pl-5 pt-2">
                                    <div class="d-flex align-items-center">
                                        <p class="fw-500">Pending</p>
                                        <h4 class="ml-3 text-new-violet">--</h4>
                                    </div>
                                    <div class="d-flex align-items-center contracts-count">
                                        <p class="fw-500">Total</p>
                                        <h4 class="ml-32px text-new-violet">--</h4>
                                    </div>
                                </div>
                                <div  class="col-lg-3 col-sm-3 col-3 mt-20">
                                    <img class="logo-image" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/contracts_logo.svg" disabled>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
                <div class="col-12 col-sm-6 col-xl-3 pl-3 pr-3 pb-3 pointer">
                    <fullscreen class="box-radius bg-white" ref="survey" @change="dataChange('survey')" >
                        <div class="widget widget2 counts bg-white text-auto div-height" >
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 fs-16">Ongoing Survey</div>
                                <!-- <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('survey')">
                                    <img class="expand-img" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/expand_logo.svg" alt />
                                </button> -->
                            </div>
                            <div class="row"  @click="permissionCheck()">
                                <div class="col-lg-9 col-sm-9 col-9 pl-12 pt-6">
                                    <div class="w-100" v-if="ajaxBusiness_and_survey && !survey_count">
                                        <div colspan="15">
                                            <div class="d-flex align-items-center justify-content-center w-100">
                                                <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" style="margin: 0 auto;" />
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="survey_count != 0">
                                        <h1 class="ml-3 text-new-violet">{{survey_count}}</h1>
                                    </div>
                                    <div v-else-if="survey_count == 0 && !ajaxBusiness_and_survey" class="fw-500 text-center"><img class="data-survey-image" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/ongoing_survey_logo.svg"></div>
                                </div>
                                <div v-if="survey_count != 0 || ajaxBusiness_and_survey" class="col-lg-3 col-sm-3 col-3 mt-20">
                                    <img class="survey-logo-image" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/ongoing_survey_logo.svg">
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
            </div>
            <!-- Highlight section -->
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-2">
                    <fullscreen class="box-radius bg-white disableButtons" ref="meetings" @change="dataChange('meetings')" >
                        <div  class="card-item bg-white text-auto pb-0 today-meetings">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <div class="fw-600 heading-font-size fs-16">Highlights</div>
                                <div class="d-flex" :class="{ 'not-allow-state' : show}">
                                    <div class="mr-4" :class="{ 'disable-state' : show}">
                                        <div class="dropdown text-capitalize">
                                            <button class="btn btn-light btn-lg btnLight dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{ selected_reminder_type.replaceAll("_", " ") }}
                                            </button>
                                            <div class="dropdown-menu reminder-dropdown-menu" aria-labelledby="dropdownMenuLink"  >
                                                <a class="dropdown-item" v-for="(category, index) in selected_reminder_type_options"
                                                    :key="index" v-on:click="changeReminderType(category)">{{ category.replaceAll("_", " ") }}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div :class="{ 'disable-state' : show}">
                                        <div class="dropdown text-capitalize">
                                            <button class="btn btn-light btn-lg btnLight dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{ selected_type }}
                                            </button>
                                            <div class="dropdown-menu cycle-dropdown-menu" aria-labelledby="dropdownMenuLink"  >
                                                <a class="dropdown-item" v-for="(category, index) in selected_type_options"
                                                    :key="index" v-on:click="changeCycle(category)">{{ category }}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" class="pointer bg-white icon-outline-css ml-8"  @click="expandData('meetings')" >
                                        <img class="expand-img" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/expand_logo.svg" alt />
                                    </button>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-center h-100 card-div-height" v-if="ajaxCallInprogress">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                    style="margin: 0 auto;" />
                            </div>
                            <div v-else>
                                <div v-if="selected_type == 'month'" class="meeting-calendar">
                                    <v-calendar is-expanded :attributes='attributes'
                                        @update:from-page="changeMonth"
                                        :from-page.sync="myFromPage"
                                        >
                                        <template #day-popover="{ dayTitle, attributes }">
                                            <div>
                                                <div class="text-xs text-gray-300 font-semibold text-center custom-month-title">
                                                    {{ dayTitle }}
                                                </div>
                                                <popover-row class="custom-indicator"
                                                    v-for="attr in attributes"
                                                    :key="attr.key"
                                                    :attribute="attr">
                                                    <div>
                                                        <div v-for="(desData, key_desData) in attr.customData.description"
                                                        :key="key_desData">
                                                            {{ key_desData + 1 +". " }}{{ desData }}
                                                        </div>
                                                    </div>
                                                </popover-row>
                                            </div>
                                        </template>
                                    </v-calendar>
                                </div>
                                <div v-if="!show">
                                    <div class="row" v-if="!open && (selected_type == 'today' || selected_type == 'tomorrow' || selected_type == 'week')">
                                        <div v-if="meeting_data.length == 0" class="no-data">
                                            <div colspan="15">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/no_scheduled_meeting.png" class="mb-3 sales-list" style="width:40% !important; height:50% !important;"/>
                                                <div class="text-center">
                                                    <span v-if="selected_reminder_type=='event'">No Scheduled Events</span>
                                                    <span v-else-if="selected_reminder_type=='follow_up'">No Scheduled Follow Ups</span>
                                                    <span v-else-if="selected_reminder_type=='task'">No Scheduled Tasks</span>
                                                    <span v-else-if="selected_reminder_type=='meeting'">No Scheduled Meetings</span>
                                                    <span v-else>No Scheduled Meetings</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="col-lg-4 col-sm-6 col-12 mb-3" v-for="(meeting, index) in meeting_data" :key="index" :class="{ 'not-allow-state' : is_click_true}">
                                            <div class="widget widget2 meetings py-3 pl-3" >
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="d-flex cards-text" style="max-width: 200px;">
                                                        <p class="text-name-ellipsis text-left call-sch fw-600 text-blue" :title="meeting.title" v-on:click="display(meeting)" v-bind:class="{'disable-state' : is_click_true}">{{meeting.title}}</p>
                                                    </div>
                                                    <div class="text-right" v-if="meeting.is_mark_complete">
                                                        <div class="dropdown" >
                                                            <a  href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="text-decoration: none"><i class="icon icon-dots-vertical fs-20 mr-2 text-black" style="color:#000"/> </a>
                                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink"  >
                                                                <a v-if="meeting.is_mark_complete" v-on:click="markSchedule(meeting,'completed')" class="dropdown-item text-flw-up font-italic fw-600">Mark as Complete</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <span v-if="selected_type == 'week'">{{meeting.meeting_start_date}} - </span>{{meeting.meeting_start_time || meeting.schedule_start_time}}
                                                        <span class="mx-1" v-if="meeting.status == 'completed' || meeting.status == 'complete' || meeting_type!=meeting && meeting.status == 'pending'">|</span>
                                                        <span v-if="meeting.status == 'completed' || meeting.status == 'complete'" class="text-flw-up mb-2">Completed</span>
                                                        <span class="text-sch-meet mb-2" v-else-if="meeting_type!=meeting && meeting.status == 'pending'">Pending</span>
                                                    </div>
                                                    <span v-if="meeting.type == 'task'" class=" mr-3 fs-14 fw-600 text-sch-meet font-italic">Task</span>
                                                    <span v-else-if="meeting.type == 'follow_up'" class=" mr-3 fs-14 fw-600 text-flw-up font-italic">Follow Up</span>
                                                    <span v-else-if="meeting.type == 'event'" class="mr-4 fs-14 fw-600 text-remind font-italic">Event</span>
                                                    <span v-else class="mr-4 fs-14 fw-600 text-meeting font-italic">Meeting</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div v-else>
                                        <div class="d-flex justify-content-between align-items-center mb-3">
                                            <img class="expand-img" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/expand_logo.svg" alt />
                                        </div>
                                    </div> -->
                                </div>
                                <div class="bg-white text-auto pb-5 " v-else>
                                    <div  class="call-details p-6 mb-4" >
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="d-flex">
                                                <span class="team-image type-follow mx-2 mt-1" v-if="meeting_type == 'follow_up'"></span>
                                                <span class="team-image type-event mx-2 mt-1" v-else-if="meeting_type == 'event'"></span>
                                                <span class="team-image type-task mx-2 mt-1" v-else-if="meeting_type == 'task'"></span>
                                                <span class="team-image type-meeting mx-2 mt-1" v-else></span>
                                                <p class="fw-600 text-capitalize">{{meeting_details.name || meeting_details.title || meeting_details.meeting_title}}</p>
                                            </div>
                                            <div>
                                                <span v-if="meeting_category == 'contact' && userPermissions.contacts_business.permitted_actions.edit" class="pointer btnpointer" @click="editMeeting(meeting_details)" ><img class="icon-images pointer"  src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/edit_icon.svg" alt=""></span>
                                                <span v-else-if="meeting_category == 'lead' && userPermissions.leads.permitted_actions.edit" class="pointer btnpointer"  @click="editMeeting(meeting_details)" ><img class="icon-images pointer"  src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/edit_icon.svg" alt=""></span>
                                                <span v-else-if="meeting_category == 'customer' && userPermissions.customers.permitted_actions.edit" class="pointer btnpointer"  @click="editMeeting(meeting_details)" ><img class="icon-images pointer"  src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/edit_icon.svg" alt=""></span>
                                                <span v-if="meeting_type == 'event' && meeting_details.is_edit" class="pointer btnpointer" @click="editMeeting(meeting_details)" ><img class="icon-images pointer"  src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/edit_icon.svg" alt=""></span>
                                                <span v-else-if="meeting_type == 'task' && meeting_details.is_edit" class="pointer btnpointer"  @click="editMeeting(meeting_details)" ><img class="icon-images pointer"  src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/edit_icon.svg" alt=""></span>
                                                <span v-else-if="meeting_type == 'follow_up' && meeting_details.is_edit" class="pointer btnpointer"  @click="editMeeting(meeting_details)" ><img class="icon-images pointer"  src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/edit_icon.svg" alt=""></span>
                                                <!--Delete icon !-->
                                                <span v-if="meeting_category == 'contact' && userPermissions.contacts_business.permitted_actions.delete" class="pointer btnpointer"  @click="deleteMeeting(meeting_details)"><img class="icon-images pointer" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/delete_icon.svg" alt=""></span>
                                                <span v-else-if="meeting_category == 'lead' && userPermissions.leads.permitted_actions.delete" class="pointer btnpointer"  @click="deleteMeeting(meeting_details)"><img class="icon-images pointer" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/delete_icon.svg" alt=""></span>
                                                <span v-else-if="meeting_category == 'customer' && userPermissions.customers.permitted_actions.delete" class="pointer btnpointer"  @click="deleteMeeting(meeting_details)"><img class="icon-images pointer" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/delete_icon.svg" alt=""></span>
                                                <span v-if="meeting_type == 'event' && meeting_details.is_delete" class="pointer btnpointer" @click="deleteMeeting(meeting_details)"><img class="icon-images pointer" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/delete_icon.svg" alt=""></span>
                                                <span v-else-if="meeting_type == 'task' && meeting_details.is_delete" class="pointer btnpointer"  @click="deleteMeeting(meeting_details)"><img class="icon-images pointer" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/delete_icon.svg" alt=""></span>
                                                <span v-else-if="meeting_type == 'follow_up' && meeting_details.is_delete" class="pointer btnpointer" @click="deleteMeeting(meeting_details)"><img class="icon-images pointer" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/delete_icon.svg" alt=""></span>
                                                <span class="pointer" @click="show=false"><img class="icon-images pointer" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/cross_button.svg" alt=""></span>
                                            </div>
                                        </div>
                                        <span class="ml-5" v-if="(meeting_details.start_date && meeting_details.start_time_meredian || meeting_details.start_date && !meeting_details.start_time_meredian || !meeting_details.start_date && meeting_details.start_time_meredian)&& meeting_type=='event'">Event - {{meeting_details.start_date}} - {{meeting_details.start_time_meredian}}</span>
                                        <span class="ml-5" v-if="(meeting_details.start_date && meeting_details.start_time_meredian || meeting_details.start_date && !meeting_details.start_time_meredian || !meeting_details.start_date && meeting_details.start_time_meredian) && meeting_type=='task'">Task Reminder - {{meeting_details.start_date}} - {{meeting_details.start_time_meredian}}</span>
                                        <span class="ml-5" v-if="(meeting_details.start_date && meeting_details.start_time_meredian || meeting_details.start_date && !meeting_details.start_time_meredian || !meeting_details.start_date && meeting_details.start_time_meredian) && meeting_type=='follow_up'">Follow Up - {{meeting_details.start_date}} - {{meeting_details.start_time_meredian}}</span>
                                        <span class="ml-5" v-if="(meeting_details.start_date && meeting_details.start_time_meredian || meeting_details.start_date && !meeting_details.start_time_meredian || !meeting_details.start_date && meeting_details.start_time_meredian) && meeting_type=='meeting'">{{meeting_details.start_date || meeting_details.schedule_start_date}} - {{meeting_details.start_time_meredian || meeting_details.schedule_start_time_meredian}}</span>
                                        <!--<span class="ml-5" v-else-if="(meeting_details.start_date && meeting_details.start_time || meeting_details.start_date && !meeting_details.start_time || !meeting_details.start_date && meeting_details.start_time) && meeting_category == 'lead'">{{meeting_details.start_date}} - {{meeting_details.start_time}}</span>-->
                                        <div class="row mt-3">
                                            <div class="col-lg-12 col-sm-12 col-md-12" >
                                                <div class="text-css mt-3" >
                                                    <div class="fw-600">Product Name</div>
                                                    <div class=" mt-2 invitee-details-follow secondary-email-list" v-if="meeting_details.products">
                                                        <span v-for="(product, index) in meeting_details.products" :key="index" class="secondary-email">{{product.name}}</span>
                                                    </div>
                                                    <div class="mt-2" v-else>
                                                        <p>{{"-"}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 col-sm-12 col-md-12">
                                                <div v-if="meeting_type == 'meeting' || meeting_type == 'event'" class="mt-3">
                                                    <div v-if="meeting_details.invitees">
                                                        <div class="fw-600">Invitees</div>
                                                        <div class="invitee-details-follow mt-2 secondary-email-list">
                                                            <p v-for="(invite,index) in meeting_details.invitees" :key="index" class="secondary-email">{{invite.email}}</p>
                                                        </div>
                                                    </div>
                                                    <div v-else-if="meeting_details.invite_email">
                                                        <div class="fw-600">Invitees</div>
                                                        <div class="invitee-details-follow secondary-email-list mt-2">
                                                            <p v-for="(invite,index) in meeting_details.invite_email" :key="index" class="secondary-email">{{invite}}</p>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div class="fw-600">No Guests</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="meeting_details.price" class="col-lg-6 col-sm-6 col-md-12">
                                                <div class="text-css mt-3" v-if="meeting_type!= 'meeting'">
                                                    <div class="fw-600">Price</div>
                                                    <div class="mt-2">
                                                        <p>{{meeting_details.price}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="(meeting_details.assigned_to_name) && (meeting_type == 'follow_up' || meeting_type=='reminder')" class="col-lg-6 col-sm-6 col-md-12" >
                                                <div class="text-css mt-3" v-if="meeting_type== 'follow_up' || meeting_type=='reminder'">
                                                    <div class="fw-600">Assigned To</div>
                                                    <div class=" mt-2">
                                                        <p>{{meeting_details.assigned_to_name}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="meeting_details.description" class="col-lg-6 col-sm-6 col-md-12">
                                                <div class="text-css mt-3" v-if="meeting_type== 'meeting'">
                                                    <div class="fw-600">Description</div>
                                                    <div class="mt-2" v-if="meeting_details.description">{{meeting_details.description}}</div>
                                                    <div class="mt-2" v-else><p>{{"-"}}</p></div>
                                                </div>
                                            </div>
                                            <div v-if="meeting_details.agenda" class="col-lg-6 col-sm-6 col-md-12 mt-3">
                                                <div class="align-items-center text-css mb-2" v-if="meeting_type=='meeting'">
                                                    <div class="fw-600">Agenda of the Meeting</div>
                                                    <div class=" mt-2" v-if="meeting_details.agenda">
                                                        <p>{{meeting_details.agenda}}</p>
                                                    </div>
                                                    <div class="mt-2" v-else>
                                                        <p>{{"-"}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="meeting_details.remind_period" class="col-lg-6 col-sm-6 col-md-12">
                                                <div class="align-items-center text-css mb-2 mt-3" v-if="meeting_type != 'meeting'">
                                                    <div class="fw-600">Reminder</div>
                                                    <div class="mt-2">
                                                        <p>Notify me {{meeting_details.remind_period}} {{meeting_details.remind_cycle}} before the {{ meeting_type.replaceAll("_", " ") }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="meeting_details.notes" class="col-lg-6 col-sm-6 col-md-12">
                                                <div class="text-css mt-3" v-if="meeting_type!= 'meeting'">
                                                    <div class="fw-600">Notes</div>
                                                    <div class="mt-2">
                                                        <p>{{meeting_details.notes}}</p>
                                                    </div>
                                                    <!-- <div class="mt-2" v-else>
                                                        <p>{{"-"}}</p>
                                                    </div> -->
                                                </div>
                                            </div>

                                            <div v-if="meeting_details.location" class="col-lg-6 col-sm-6 col-md-12">
                                                <div class="text-css mt-3" v-if="meeting_type== 'meeting'">
                                                    <div class="fw-600">Location</div>
                                                    <div class="mt-2">
                                                        <p>{{meeting_details.location}}</p>
                                                    </div>
                                                    <!-- <div class="mt-2" v-else>
                                                        <p>{{"-"}}</p>
                                                    </div> -->
                                                </div>
                                            </div>

                                            <div class="col-lg-12 col-sm-12 col-md-12">
                                                <div class="text-css mt-3">
                                                    <div class="fw-600" v-if="meeting_details.is_mark_complete">Mark As</div>
                                                    <button type="button" class="pointer btn btn-done mt-2 text-capitalize fs-14 fw-500" @click="markSchedule(meeting_details,'complete')" v-if="meeting_details.is_mark_complete">Complete</button>
                                                    <div class="mt-10" v-if="userPermissions.call_reports.permitted_actions.create && meeting_type == 'meeting' && loggedInUser.full_name">
                                                        <div class="dropdown"  v-if="userPermissions.call_reports.permitted_actions.create || userPermissions.draft_call_reports.permitted_actions.create">
                                                            <div class="dropdown text-capitalize">
                                                                <button class="btn btn-done btn-wide dropdown-toggle" href="#"
                                                                    role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                                                    aria-haspopup="true" aria-expanded="false">
                                                                    + Create Call Report
                                                                </button>
                                                                <div class="dropdown-menu cust-dropdown-menu"
                                                                    aria-labelledby="dropdownMenuLink">
                                                                    <!-- <a class="dropdown-item"
                                                                        v-for="(category, index) in call_report_category_options" :key="index"
                                                                        v-on:click="addCallReport(meeting_details,category)">{{ category }}</a> -->
                                                                    <a class="dropdown-item" v-on:click="addCallReport(meeting_details, 'External Meeting')">External Meeting</a>
                                                                    <a class="dropdown-item" v-on:click="addCallReport(meeting_details, 'Internal Meeting')">Internal Meeting</a>
                                                                    <a class="dropdown-item" v-on:click="addCallReport(meeting_details, 'Review Meeting')">Review Meeting</a>
                                                                    <a class="dropdown-item" v-on:click="addCallReport(meeting_details, 'Sales Meeting')">Sales Meeting</a>
                                                                </div>
                                                            </div>
                                                            <!-- <a class="btn btn-new-green btn-wide dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                + Create Call Report
                                                            </a>
                                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink"  >
                                                                <a class="dropdown-item" v-for="(category, index) in call_report_category_options"
                                                                    :key="index" v-on:click="addCallReport(meeting_details,category)">{{ category }}</a>
                                                            </div> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
            </div>
            <!-- Deals in Pipeline section -->
            <div class="row mt-5">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12 pr-0">
                    <fullscreen ref="pipeline" @change="dataChange('pipeline')" class="box-radius bg-white mr-4" >
                        <div  class="bg-white text-auto deals mr-4">
                            <div class="d-flex justify-content-between aline-items-center p-4">
                                <div class="fw-600 fs-16">Deals in Pipeline</div>
                                <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('pipeline'), addClass()">
                                    <img class="expand-img" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/expand_logo.svg" alt />
                                </button>
                            </div>
                            <div class="fw-600 fs-12 px-4">Note: Please click on the slice to see the details</div>
                            <div v-if="list_data.length == 0" class="text-center font-weight-bold">
                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/territory-sales.png" class="mb-3 response-list"/>
                                <div class="text-center mt-10 text-muted fw-500">No Deals in pipeline!</div>
                            </div>
                            <div class="d-flex align-items-center justify-content-center h-100 card-follow-height" v-else-if="ajaxPipelineInprogress">
                                <half-circle-spinner :animation-duration="1000" :size="60"  color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="row">
                                <div class="col-lg-7 col-md-7 col-sm-12 col-12">
                                    <div id="pipelineDiv" class="mt-5 mx-4 pipelineDiv"></div>
                                    <p class="fw-600 text-center pt-2">Pipeline</p>
                                </div>
                                <div class="col-lg-5 col-md-5 col-sm-12 col-12">
                                    <p v-if="deal_pipeline_data != ''" class="fw-600 text-center pt-8 text-capitalize">{{this.deal_name}} Pipeline</p>
                                    <div id="dealsDiv" class="mt-3 dealsDiv"></div>
                                    <p v-if="deal_pipeline_data != ''" class="fw-600 text-center pt-13">Deals</p>
                                </div>
                                <!-- <div id="legenddiv"></div> -->
                            </div>
                        </div>
                    </fullscreen>
                </div>
            </div>
            <div class="row">
                <!-- Sales Revenue section -->
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 pr-3 mt-5">
                    <fullscreen class="box-radius bg-white" ref="revenue" @change="dataChange('revenue')" >
                        <div  class="card-item bg-white text-auto">
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 fs-16">Sales Revenue</div>
                                <button type="button" class="pointer bg-white icon-outline-css"  @click="expandData('revenue') , addClass()">
                                    <img class="expand-img" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/expand_logo.svg" alt />
                                </button>
                            </div>
                            <div class="d-flex align-items-center justify-content-center" v-if="loadSalesRevenueSection" style="height: 372px;">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="p-1 mt-2">
                                <div v-if="dateRange.length" style="border-bottom: 1px solid #a9aaad;">
                                    <div class="d-flex justify-content-between align-items-center"
                                        style="background: #41b883; border-radius: 12px; padding-left: 10px; padding-right: 10px; margin-top: 4px; margin-bottom: 8px; width: 16em;">
                                        <input type="text"
                                            :value="('0'+new Date(dateRange[0]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[0]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[0]).getFullYear()+' to '+('0'+new Date(dateRange[1]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[1]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[1]).getFullYear()"
                                            style="color: #fff; background: #41b883; width: 14em;" disabled />
                                        <span
                                            @click="dataClose(), dateRange=[]"
                                            style="color: #fff; cursor: pointer;">&#10005;</span>
                                    </div>
                                </div>
                                <date-picker v-else @change="updatecreationDate()" v-model="dateRange" format="DD/MM/YYYY"
                                        range class="date-width calendar-edit-per callreport-listdate calendar-height-top" :show-second="false"  :disabled-dates="disableDateRange"
                                    :lang="lang" :clearable="true" confirm :not-after="new Date()" confirm-text="APPLY" type="date">
                                </date-picker>
                            </div>
                            <div v-if="!loadSalesRevenueSection" id="selectordiv"></div>
                            <div v-if="!loadSalesRevenueSection" id="salesRevenueDiv"></div>
                        </div>
                    </fullscreen>
                </div>
                <!-- Target Achieved section -->
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 pl-3 mt-5">
                    <fullscreen class="box-radius bg-white" ref="target" @change="dataChange('target')" >
                        <div class="card-item card-height bg-white text-auto">
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 fs-16">Target Achieved per product</div>
                                <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('target')">
                                    <img class="expand-img" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dashboard/expand_logo.svg" alt />
                                </button>
                            </div>
                            <div id="targetachievedDiv" >
                            </div>
                        </div>
                    </fullscreen>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <delete-meeting-confirmation v-if="delete_meetings"  modal_name="deleteMeetings" @deleteMeetingConfirmation="deleteMeetingConfirmation"  @cancelDelete="cancelDelete"></delete-meeting-confirmation>
        <delete-schedule-modal @hideDeleteEvent="hideDeleteEvent" :selected_id="selected_id" v-if="delete_event" modal_name="deleteEvent" @deleteReminder="deleteMeetingConfirmation" :category_type="category_type" :category_data="category_data"></delete-schedule-modal>
        <contact-meetings @hide-sm-modal="HideSmModel" v-if="sm_modal" :sm_id="sm_id" :sm_mode="sm_mode" modal_name="OpenSmModel"></contact-meetings>
        <leads-meeting  :schedule_data="schedule_data" :meeting_id="meeting_id" :lead_meeting_id="lead_meeting_id" v-if="schedule_meeting" @hideScheduleMeeting="hideScheduleMeeting" modal_name="schedule_meeting"></leads-meeting>
        <customer-meetings @hideCustomerMeeting="hideCustomerMeeting" v-if="customer_meeting" :customer_id="customer_id" :customer_mode="customer_mode" modal_name="customer_modal" @hide-sm-on-save="hideCustomerMeeting"></customer-meetings>
        <create-reminder :reminderType="meeting_category" v-if="createReminderShow" :mode_id="lead_meeting_id" :view_mode="'edit'" modal_name="createReminder" @hideCreateReminder="hideCreateReminder"></create-reminder>
    </div>
</template>
<script>
import moment from 'moment';
import {HalfCircleSpinner} from "epic-spinners";
import { SweetModal } from 'sweet-modal-vue';
import dashboard from "../mixins/dashboard.js";
import convert from "../mixins/convert.js";
import contacts from "../mixins/contacts.js";
import leads from "../mixins/leads"
import customers from "../mixins/customer.js";
import reminder from "../mixins/reminders.js";
const CreateReminder = () => import("../Reminders/CreateReminder");
const ContactMeetings = () => import('../Contacts/AddMeetings');
const CustomerMeetings = () => import('../Customers/AddScheduleMeetings');
const DeleteMeetingConfirmation = () => import('../alertModals/DeleteMeetingConfirmation')
const DeleteScheduleModal = () => import('../alertModals/DeleteScheduleModal')
const LeadsMeeting = () => import("../Leads/ScheduleMeeting")
import PopoverRow from 'v-calendar/lib/components/popover-row.umd.min'
export default {
    data(){
        return{
            loadSalesRevenueSection: false,
            //ajaxCallInProgress: false,
            ajaxCallreport:false,
            // ajaxBusiness:false,
            // ajaxSurvey:false,
            selected_id:'',
            delete_event:false,
            createReminderShow: false,
            //call_report_category_options: [],
            selected_calendar_month: moment(new Date().toUTCString()).format("M"),
            selected_calendar_year: moment(new Date().toUTCString()).format("YYYY"),
            myFromPage: null,
            todos: [],
            is_click_true:false,
            ajaxCallInprogress:false,
            ajaxTargetInprogress:false,
            ajaxPipelineInprogress:false,
            schedule_data:"induction",
            lead_meeting_id:'',
            meeting_id: null,
            schedule_meeting: false,
            delete_meetings:false,
            delete_schedule:false,
            sm_id: '',
            customer_id:'',
            customer_mode:'',
            sm_modal: false,
            customer_meeting:false,
            sm_mode: '',
            load_meeting:false,
            currency:'',
            rangeDate: [],
            graph_scale:[],
            show:false,
            isActive:true,
            chart: {},
            selected_type: "today",
            selected_schedule:"today",
            selected_type_options: ['today','tomorrow','week', 'month'],
            selected_reminder_type: "all",
            selected_reminder_type_options: ['all','event','follow_up','meeting','task'],
            select_month: null,
            open: false,
            open:false,
            list_data: [],
            target_achieved_data: [],
            warning_msg: '',
            success_msg: '',
            selected_graph: null,
            target_data: [],
            busines_count: 0,
            callreport_count: 0,
            survey_count: 0,
            Custom: false,
            sales_revenue_data: [],
            deal_pipeline_data: [],
            deal_name:'',
            created_report_date: [new Date() , new Date()],
            dateRange: [],
            creation_date: [],
            pickerOptions:{
                disabledDate(time){
                    return time.getTime() > Date.now();
                }
            },
            lang: {
                type: "en",
                days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                months: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                pickers: [
                    "next 7 days",
                    "next 30 days",
                    "previous 7 days",
                    "previous 30 days"
                ],
                placeholder: {
                    date: "Select Date",
                    dateRange: "Select Date Range"
                },
            },
            meeting_data:[],
            meeting_details:[],
            meeting_name:'',
            meeting_type:'',
            meeting_category:'',
            category_type:'Follow Up',
            category_data:'Follow up meeting',
            ajaxBusiness_and_survey: false
        }
    },
    components:{
        HalfCircleSpinner,
        SweetModal,
        ContactMeetings,
        DeleteMeetingConfirmation,
        DeleteScheduleModal,
        LeadsMeeting,
        CustomerMeetings,
        CreateReminder,
        PopoverRow
    },
    mixins:[dashboard,convert,contacts,leads,customers,reminder],
    methods:{
        //add call report
        /**@params = meeting, @params = category */
        addCallReport(meeting,category) {
            this.$store.commit("setCallReportCategory", category);
            localStorage.setItem("callReportCategory", category)
            localStorage.setItem('meetingDetails',JSON.stringify(meeting))
            this.$router.push("/callreport");
        },
        //hide the create reminder
        hideCreateReminder(){
            this.createReminderShow = false;
            this.loadMeetingData()
        },
        //get the type of the call report type
        // getCallReportType() {
        //     this.$http.get("/call_report/get_call_report_category").then(res => {
        //         if (res.data.status_id == 1) {
        //             res.data.response.value.forEach(x => {
        //                 this.call_report_category_options.push(x.name);
        //             });
        //         }
        //     });
        // },
        async markSchedule(data,type){
            let id = data.id || data.meeting_id
            let params = {
                status: type
            }
            let response = await this.PatchRemindersById(id, params)
            this.success_msg = response.message
            this.$refs.success_modal.open();
            setTimeout(() => {
                this.$refs.success_modal.close();
                this.loadMeetingData()
            }, 2000);
        },
        changeReminderType(reminderType){
            this.selected_reminder_type = reminderType
        },
        changeCycle(cycle){
            this.selected_type = cycle
        },
        changeMonth (page) {
            this.selected_calendar_month = page.month;
            this.selected_calendar_year = page.year;
        },
        //hide the lead schedule meeting modal
        hideScheduleMeeting(){
            this.schedule_meeting = false
            this.loadMeetingData()
        },
        //hide the contact schedule meeting modal
        HideSmModel(){
            this.sm_modal = false
            this.loadMeetingData()
        },
        //hide the customer schedule meeting modal
        hideCustomerMeeting(){
            this.customer_meeting = false
            this.loadMeetingData()
        },
        //hide the delete schedule modal
        hideDeleteEvent(){
            this.delete_event = false
        },
        //cancel the delete meeting
        cancelDelete(){
            this.delete_meetings = false
        },
        //delete the meeting based on the type of the meeting
        deleteMeeting(){
            if(this.meeting_type == 'event'){
                this.category_type = 'Meeting'
                this.category_data = 'scheduled meeting'
            } else if(this.meeting_type == 'task'){
                this.category_type = 'Reminder'
                this.category_data = 'Task Reminder'
            } else if(this.meeting_type == 'follow_up'){
                this.category_type = 'Follow Up'
                this.category_data = 'Follow up meeting'
            }
            if(this.meeting_type == 'event' || this.meeting_type == 'task' || this.meeting_type == 'follow_up'){
                this.delete_event = true
                setTimeout(() => {
                    this.$modal.show('deleteEvent')
                }, 1000);
            } else{
                this.delete_meetings = true
                setTimeout(() => {
                    this.$modal.show('deleteMeetings');
                }, 500);
            }
        },
        //get the modal of confirmation before the deletion
        async deleteMeetingConfirmation(){
            let data = this.meeting_details
            this.selected_id = data.id
            let response
            if(this.meeting_type == 'event' || this.meeting_type == 'task' || this.meeting_type == 'follow_up'){
                response = await this.DeleteReminderById(data.id);
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadMeetingData();
                }, 3000);
            } else{
                if(this.meeting_category == 'contact'){
                response = await this.deleteContactMeetingDetailsById(data.id)
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadMeetingData()
                }, 2000);

            } else if(this.meeting_category == 'customer'){
                response = await this.deleteMeetingDetailsById(data.id)
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadMeetingData()
                }, 2000);
            } else if(this.meeting_category == 'lead'){
                    response = await this.deleteMeetingById(data.activity_id)
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.loadMeetingData()
                    }, 2000);
                }
            }
        },

        deleteSchedule(){
            this.delete_schedule = true
            setTimeout(() => {
                this.$modal.show('deleteSchedules');
            }, 500);
        },
        //get the delete schedule confirmation for followups
        async deleteScheduleConfirmation(){
            this.success_msg = "Follow Ups Deleted"
            this.$refs.success_modal.open();
            setTimeout(() => {
                this.$refs.success_modal.close();
                //this.loadMeetingData()
            }, 2000);
        },
        //edit the meeting based on the meeting type
        /**@params = data */
        editMeeting(data){
            this.lead_meeting_id = data.id
            if(this.meeting_type == 'event' || this.meeting_type == 'task' || this.meeting_type == 'follow_up'){
                this.createReminderShow = true;
                setTimeout(() => {
                    this.$modal.show('createReminder')
                }, 1000)
            } else{
                if(this.meeting_category == 'contact'){
                    this.sm_id = data.id
                    this.sm_mode = 'edit'
                    this.sm_modal = true
                    this.$forceUpdate();
                    setTimeout(() => {
                        this.$modal.show('OpenSmModel')
                    }, 1000)
                } else if(this.meeting_category == 'lead' ){
                    localStorage.setItem("leads_type",'Manual')
                    this.meeting_id = null
                    this.meeting_id = data.activity_id
                    this.schedule_meeting = true
                    setTimeout(() => {
                        this.$modal.show("schedule_meeting")
                    }, 1000);
                } else if(this.meeting_category == 'customer'){
                    this.customer_id = data.id
                    this.customer_mode = 'edit'
                    this.customer_meeting = true
                    setTimeout(() => {
                        this.$modal.show('customer_modal')
                    }, 1000)
                }
            }

        },
        //check the permission for user roles
        permissionCheck(){
            if(this.loggedInUser.user_role != 'generic_user'){
                this.$router.push('/surveyDashboard')
            } else {
                this.$toasted.global.error("Permission Denied")
            }
        },
        //set the date and convert the date format
        dataClose(){
            let date = this.rangeDate
            let start_date = this.convertFilter(date[0])
            let end_date = this.convertFilter(date[1])
            let newValue = start_date + ',' + end_date
            newValue = newValue.split(",")
            this.created_report_date = newValue
            this.loadSalesRevenueAPI()
        },
        //add the classes to expand the div size in full screen
        addClass(){
            var revenue = document.getElementById('salesRevenueDiv');
            revenue.classList.toggle('salesRevenueDiv-expand');
            var target = document.getElementById('targetachievedDiv');
            target.classList.toggle('targetachievedDiv-expand');
            var pipeline = document.getElementById('pipelineDiv');
            pipeline.classList.toggle('pipelineDiv-expand');
        },
        //update the creation date and change the date format
        updatecreationDate(){
            if (this.dateRange) {
                let start_date = this.convertFilter(this.dateRange[0])
                let end_date = this.convertFilter(this.dateRange[1])
                let newValue = start_date + ',' + end_date
                newValue = newValue.split(",")
                this.created_report_date = newValue
                this.loadSalesRevenueAPI()
            } else {
                this.creation_date = ''
                this.created_report_date = ''
            }
            this.$forceUpdate()
        },
        expandData(value) {
            if(value == 'survey'){
                this.$refs["survey"].toggle();
            } else if(value == 'report'){
                this.$refs["report"].toggle();
            } else if(value == 'meetings'){
                this.$refs["meetings"].toggle();
            } else if(value == 'contacts'){
                this.$refs["contacts"].toggle();
            } else if(value == 'contracts'){
                this.$refs["contracts"].toggle();
            } else if(value == 'survey'){
                this.$refs["survey"].toggle();
            } else if(value == 'revenue'){
                this.$refs["revenue"].toggle();
                this.addClass();
            } else if(value == 'target'){
                this.$refs["target"].toggle();
                this.addClass();
            } else if(value == 'pipeline'){
                this.$refs["pipeline"].toggle();
                this.addClass();
            }
        },
        //change the data
        /**@params = value */
        dataChange(value) {
            if(value == 'survey'){
                this.survey = value;
            } else if(value == 'report'){
                this.report = value;
            } else if(value == 'meetings'){
                this.meetings = value;
            } else if(value == 'contacts'){
                this.contacts= value;
            } else if(value == 'contracts'){
                this.contracts = value;
            } else if(value == 'survey'){
                this.survey = value;
            } else if(value == 'pipeline'){
                this.pipeline= value;
                this.addClass();
            } else if(value == 'target'){
                this.target = value;
                this.addClass();
            } else if(value == 'revenue'){
                this.revenue = value;
                this.addClass();
            }
        },
        //disable the date range field
        disableDateRange(){
            const today = new Date();
            var dateOffset = (24*60*60*1000) * (365*5); //5 yrs
            return date < today && date >today.setTime(today.getTime() - dateOffset)
        },
        dateSettings(){
            let date = []
            var dateOffset = (24*60*60*1000) * (365*5); //5 yrs
            var newDate = this.convertFilter(new Date());
            var oldDate = new Date();
            oldDate.setTime(oldDate.getTime() - dateOffset);
            this.created_report_date= [this.convertFilter(oldDate),newDate]
            this.rangeDate = [this.convertFilter(oldDate),newDate]
        },
        handleChange(value, type) {
            if (type === 'second') {
                this.open = false;
            }
        },
        //APi call to load the business contacts data
        async loadBusinessAndSurveyCount(){
            this.ajaxBusiness_and_survey = true;
            let response = await this.getBusinessContactsAndSurveyCounts();
            this.busines_count = response.count
            this.survey_count = response.survey_count
            this.ajaxBusiness_and_survey = false;
        },
        //APi call to load the call report  data
        async loadCallReportsData(){
            this.ajaxCallreport = true;
            let response = await this.getCallReportData()
            this.callreport_count = response
            this.ajaxCallreport = false;
        },
        //APi call to load the meetings data
        async loadMeetingData(){
            this.ajaxCallInprogress = true
            let params = {
                cycle: this.selected_type,
                filter_by: this.selected_reminder_type,
                year: this.selected_calendar_year,
                month: this.selected_calendar_month
            }
            let response = await this.getMeetingData(params)
            this.meeting_data = response.response
            this.todos = response.response
            this.ajaxCallInprogress = false
            this.show=false
        },
        //api call to check on going survey data
        // async loadOngoingSurveyData(){
        //     this.ajaxSurvey = true;
        //     let response = await this.getOngoingSurveyData()
        //     this.survey_count = response
        //     this.ajaxSurvey = false;
        // },
        //load pipeline data
        async loadPipelineData(){
            this.ajaxPipelineInprogress = true
            if(this.list_data.length){
                let pipeline_data = []
                pipeline_data = this.list_data[0].response
                var chart = am4core.create("pipelineDiv", am4charts.PieChart);

                // Add data
                chart.data = pipeline_data
            }
            // Add and configure Series
            var pieSeries = chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "percentage";
            pieSeries.dataFields.category = "pipeline_name";
            pieSeries.dataFields.id = "deal_pipeline_id";

            // Disable ticks and labels
            //pieSeries.labels.template.disabled = true;
            //pieSeries.ticks.template.disabled = true;

            // // Add a legend
            // chart.legend = new am4charts.Legend();

            // /* Create a separate container to put legend in */
            // var legendContainer = am4core.create("legenddiv", am4core.Container);
            // legendContainer.width = am4core.percent(100);
            // legendContainer.height = am4core.percent(100);
            // chart.legend.parent = legendContainer;
            // chart.legend.labels.template.maxWidth = 150;
            // chart.legend.labels.template.truncate = true;

            pieSeries.slices.template.events.on("hit", (ev)=>{
                const id = ev.target.dataItem.id;
                this.loadDealPipelineDataAPI(id);
            });
            this.ajaxPipelineInprogress = false

        },
        async loadDealPipelineDataAPI(id){

            try {
                let params = {
                    pipeline_id: id
                }
                let response = await this.getDealPipelineData(params)
                this.deal_name = response.search_key
                this.deal_pipeline_data = response.response
                if(this.deal_pipeline_data == ''){

                    var style = document.createElement('style');
                    style.type = 'text/css';
                    style.innerHTML = '.pipeCss {width: 130px!important;height: 100px!important;margin:auto!important;margin-top:20px !important}';
                    document.getElementsByTagName('head')[0].appendChild(style);
                    document.getElementById('dealsDiv').innerHTML = "<div class=text-center><img id= pipe-img src=/static/images/leads.png class=mt-3><div class='mt-4 text-muted fw-500'>No deals added!</div></div>";
                    document.getElementById('pipe-img').className = 'pipeCss';
                } else {
                    this.loadDealPipelineData()
                }

            } catch (reason) {
            }

        },
        loadDealPipelineData(){
            var deals_chart = am4core.create("dealsDiv", am4charts.PieChart);

            // Add data
            deals_chart.data = this.deal_pipeline_data;

            // Add and configure Series
            var dealPieSeries = deals_chart.series.push(new am4charts.PieSeries());
            dealPieSeries.dataFields.value = "percentage";
            dealPieSeries.dataFields.category = "name";

            // Disable ticks and labels
            dealPieSeries.labels.template.disabled = true;
            dealPieSeries.ticks.template.disabled = true;
        },
        //Api call to load the sales revenue
        async loadSalesRevenueAPI(){
            this.loadSalesRevenueSection = true;
            /**@params = range */
            try {
                let params = {
                    range: this.created_report_date
                }
                let response = await this.getSalesRevenueData(params)
                this.sales_revenue_data = response.response.timing
                const result = []
                const scale = []
                const map = new Map();
                for (const item of this.sales_revenue_data) {
                        map.set(item.total, true);
                        result.push({
                            date: item.concat_time || '',
                            value:item.total
                        });
                }
                this.sales_revenue_data = result
                this.graph_scale = response.response.graph_scale
                for (const scaledata of this.graph_scale) {
                    scale.push(scaledata)
                }
                this.graph_scale = scale
                if(this.graph_scale == ''){
                    this.loadSalesRevenueSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML = '.forecastClass {  width: 40%!important;height: 40%!important;margin:auto!important;margin-top:50px !important }';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('salesRevenueDiv').innerHTML = "<div class=text-center><img id= forecast-img src=/static/images/forecast.png class=mt-3><div class='mt-4 text-muted fw-500'>No Sales!</div></div>";
                        document.getElementById('forecast-img').className = 'forecastClass';
                    }, 1000);
                    } else {
                        this.loadSalesRevenueData();
                        this.loadSalesRevenueSection = false;
                    }
            } catch (reason) {
                this.loadSalesRevenueSection = false;
            }
            this.loadSalesRevenueSection = false;
        },
        //load sales revenue data
        loadSalesRevenueData(){
            // Themes begin
            setTimeout(() => {
                am4core.useTheme(am4themes_animated);

                var chart = am4core.create("salesRevenueDiv", am4charts.XYChart);
                let vueThis = this
                let scale = vueThis.graph_scale
                chart.cursor = new am4charts.XYCursor();
                chart.cursor.lineX.disabled = true;
                chart.cursor.lineY.disabled = true;

                // Enable scrollbar
                chart.scrollbarX = new am4core.Scrollbar();

                // Add data
                chart.data = this.sales_revenue_data;
                // Create axes
                var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                dateAxis.renderer.grid.template.location = 0.5;
                dateAxis.dateFormatter.inputDateFormat = "yyyy-MM-dd";
                dateAxis.renderer.minGridDistance = 40;
                dateAxis.tooltipDateFormat = "MMM dd, yyyy";
                dateAxis.dateFormats.setKey("day", "dd");
                dateAxis.title.text = "Time"
                dateAxis.title.fontWeight = 500;

                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.title.text = "Amount in 1000(" + vueThis.currency + ")";
                valueAxis.title.fontWeight = 500;
                valueAxis.numberFormatter.numberFormat = "#a";

                var ylabel = valueAxis.renderer.labels.template;
                ylabel.truncate = true;
                ylabel.maxWidth = 80;
                ylabel.tooltipText = "{value}";

                // Create series
                var series = chart.series.push(new am4charts.LineSeries());
                series.dataFields.dateX = "date";
                series.dataFields.valueY = "value";
                series.tooltipText = "{valueY}";
                series.tooltip.pointerOrientation = "vertical";
                series.tooltip.background.fillOpacity = 0.5;
                series.strokeDasharray = 3;
                series.strokeWidth = 2
                series.strokeOpacity = 0.3;
                series.strokeDasharray = "3,3"

                var bullet = series.bullets.push(new am4charts.CircleBullet());
                bullet.strokeWidth = 2;
                bullet.stroke = am4core.color("#fff");
                bullet.setStateOnChildren = true;
                bullet.propertyFields.fillOpacity = "opacity";
                bullet.propertyFields.strokeOpacity = "opacity";

                var hoverState = bullet.states.create("hover");
                hoverState.properties.scale = 1.7;

                function createTrendLine(data) {
                var trend = chart.series.push(new am4charts.LineSeries());
                trend.dataFields.valueY = "value";
                trend.dataFields.dateX = "date";
                trend.strokeWidth = 2
                trend.stroke = trend.fill = am4core.color("#c00");
                trend.data = data;

                var bullet = trend.bullets.push(new am4charts.CircleBullet());
                bullet.tooltipText = "{date}\n[bold font-size: 17px]value: {valueY}[/]";
                bullet.strokeWidth = 2;
                bullet.stroke = am4core.color("#fff")
                bullet.circle.fill = trend.stroke;

                var hoverState = bullet.states.create("hover");
                hoverState.properties.scale = 1.7;

                return trend;
                };

                createTrendLine([
                { "date": date, "value": value },
                { "date": date, "value": value }
                ]);

                var lastTrend = createTrendLine([
                    { "date": date, "value": value },
                    { "date": date, "value": value }
                ]);

                // Initial zoom once chart is ready
                lastTrend.events.once("datavalidated", function(){
                series.xAxis.zoomToDates(new Date(2012, 0, 2), new Date(2012, 0, 13));
                });
            }, 1000);
        },
        //Api call to get the target achieved data
        async loadTargetAchievedAPI(){
            this.ajaxTargetInprogress = true
            try{
            let response = await this.getTargetAchievedData()
            this.target_data = response.response.sales_per_product
            const result = []
                const map = new Map();
                for (const item of this.target_data) {
                    if(!map.has(item.sum)){
                        map.set(item.sum, true);
                        result.push({
                            country: item.product_year || '',
                            visits:item.sum,
                        });
                    }
                }
                this.target_data = result
                if(this.target_data == ''){
                    var style = document.createElement('style');
                    style.type = 'text/css';
                    style.innerHTML = '.cssClass {width: 30%!important;height: 30%!important;margin:auto!important;margin-top:80px !important }';
                    document.getElementsByTagName('head')[0].appendChild(style);
                    document.getElementById('targetachievedDiv').innerHTML = "<div class=text-center><img id= data-text src=/static/images/product.png class=mt-3><div class='mt-4 text-muted fw-500'>No Products!</div></div>";
                    document.getElementById('data-text').className = 'cssClass';

                } else {
                    this.loadTargetAchievedData();
                }
                this.ajaxTargetInprogress = false
            }catch (reason){
                this.ajaxTargetInprogress = false
            }

        },
        async loadTargetAchievedData(){
            let vueThis = this
            am4core.useTheme(am4themes_animated);
            var chart = am4core.create("targetachievedDiv", am4charts.XYChart);
            chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
            chart.data = vueThis.target_data

            var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.dataFields.category = "country";
            categoryAxis.renderer.minGridDistance = 10;
            categoryAxis.title.text = "Products";
            categoryAxis.title.fontWeight = 500;

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            valueAxis.renderer.grid.template.location = 0;
            valueAxis.dataFields.category = "visits";
            valueAxis.renderer.minGridDistance = 30;
            valueAxis.title.text = "Amount in 1000(" + vueThis.currency + ")";
            valueAxis.title.fontWeight = 500;
            valueAxis.numberFormatter.numberFormat = "#a";
            //create label
            var label = categoryAxis.renderer.labels.template;
            label.truncate = true;
            label.maxWidth = 100;
            label.tooltipText = "{country}";
            var ylabel = valueAxis.renderer.labels.template;
            ylabel.truncate = true;
            ylabel.maxWidth = 80;
            ylabel.tooltipText = "{value}";
            categoryAxis.events.on("sizechanged", function(ev) {
            var axis = ev.target;
            var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
            if (cellWidth < axis.renderer.labels.template.maxWidth) {
                axis.renderer.labels.template.rotation = -45;
                axis.renderer.labels.template.horizontalCenter = "right";
                axis.renderer.labels.template.verticalCenter = "middle";
            }
            else {
                axis.renderer.labels.template.rotation = 0;
                axis.renderer.labels.template.horizontalCenter = "middle";
                axis.renderer.labels.template.verticalCenter = "top";
            }
            });
            var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.categoryX = "country";
            series.dataFields.valueY = "visits";
            series.columns.template.tooltipText = "{valueY.value}";
            series.columns.template.tooltipY = 0;
            series.columns.template.strokeOpacity = 0;

            var valueLabel = series.bullets.push(new am4charts.LabelBullet());
            valueLabel.label.text = "{visits}";
            valueLabel.label.fontSize = 12;
            valueLabel.label.fontWeight = 600;
            valueLabel.label.horizontalCenter = "top";
            valueLabel.label.verticalCenter = "top";
            valueLabel.label.fill = am4core.color("#ffffff");
            valueLabel.label.dx = -30;
            valueLabel.label.dy = 10;

            // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
            series.columns.template.adapter.add("fill", (fill, target) => {
            return chart.colors.getIndex(target.dataItem.index);
            });
        },
        //show the meeting data in details
        /**@params = meeting */
        async display(meeting){
            this.is_click_true = true
            let id = meeting.meeting_id
            this.meeting_type = meeting.type
            this.meeting_category = meeting.category
            this.meeting_name = meeting.name
            let response
            if(this.meeting_category == 'contact'){
                this.meeting_details =[]
                this.load_meeting = true
                response = await this.getContactsMeetingDetails(id);
                this.meeting_details = response.response
                if(response.status_id == 1){
                    this.show=!this.show
                }
                this.load_meeting = false
            } else if(this.meeting_category == 'lead'){
                this.meeting_details =[]
                this.load_meeting = true
                response = await this.getMeetingDetails(id)
                this.meeting_details = response.response
                if(response.status_id == 1){
                    this.show=!this.show
                }
            } else if(this.meeting_category == 'customer'){
                this.meeting_details =[]
                this.load_meeting = true
                response = await this.getCustomerMeetingDetails(id)
                this.meeting_details = response.response
                if(response.status_id == 1){
                    this.show=!this.show
                }
            } else if(this.meeting_type == 'event' || this.meeting_type == 'follow_up' || this.meeting_type == 'task'){
                this.meeting_details =[]
                this.load_meeting = true
                response = await this.GetReminderById(id)
                this.meeting_details = response.response
                if(response.status_id == 1){
                    this.show=!this.show
                }
            }
            setTimeout(() => {
                this.is_click_true = false
            }, 500);

        },

    },
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        attributes() {
            return [
                // Attributes for todos
                {
                    key: 'today',
                    highlight: {
                        color: 'blue',
                    },
                    dates: new Date(),
                },
                ...this.todos.map(todo => ({

                    dates: todo.date,
                    dot: {
                        color: 'red',
                    },
                    popover: {
                        visibility: 'hover',
                        placement: 'right',
                        hideIndicator: 'true',
                    },
                    customData: todo,
                })),
            ];
        },
    },
    async mounted(){
        // this.ajaxCallInProgress = true;
        this.ajaxTargetInprogress = true
        // this.ajaxBusiness = true;
        this.ajaxCallreport = true;
        this.ajaxBusiness_and_survey = true;
        // this.ajaxSurvey = true;
        this.loadSalesRevenueSection = true;
        this.ajaxCallInprogress = true
        //this.getCallReportType()
        this.dateSettings(),
        this.currency = this.loggedInUser.currency.symbol;
        await this.getAllData(),
        this.loadTargetAchievedAPI(),
        // this.loadBusinessContactsData(),
        this.loadCallReportsData(),
        // this.loadOngoingSurveyData(),
        this.loadSalesRevenueAPI(),
        this.loadMeetingData()
        this.loadBusinessAndSurveyCount();
        // setTimeout(() => {
        //     this.ajaxCallInProgress = false;
        // },500);
    },
    watch:{
        selected_type: function() {
            this.loadMeetingData();
        },
        selected_reminder_type: function() {
            this.loadMeetingData();
        },
        selected_calendar_month: function() {
            this.loadMeetingData();
        },
        // selected_type(){
        //     if(this.selected_type == 'month'){
        //         this.open = true
        //     }
        //     else{
        //         this.open = false
        //     }
        // }
    }
}
</script>

<style scoped>
.secondary-email-list {
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
}
.secondary-email {
    padding: 3.5px 19px 3.5px 7.5px;
    border-radius: 5px;
    background-color: rgba(197, 223, 253, 0.28);
    white-space: nowrap;
    margin: 5px;
}
.no-data{
    margin: 0 auto;
    display: block;
    text-align: center;
}
.dropdown-callreport {
    position: absolute;
    top: 160px !important ;
    left: 664px !important ;
    transform-origin: center bottom;
    z-index: 2032;
}
.cards-text {
    align-items: center;
    justify-content: center;
    text-align: center;
}
 .team-image {
    color: #fff;
    font-weight: 500;
    font-size: 12px;
    background: #F6923E;
    border-radius: 50%;
    width: 23px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.meeting_dropdown{
    border: 1px solid transparent;
    border-bottom: 1px solid black;
    width:100px;
}
.btn-done{
    background-color:#1D8A63;
    color:#fff;
    border-radius:5px;
}
.btn-later{
    background-color:#F6923E;
    color:#fff;
    border-radius:5px;
}
.text-meeting{
    color:#be0a94!important
}
.text-sch-meet{
    color:#be4e0a !important
}
.text-flw-up{
    color:#3a8007 !important
}
.text-remind {
    color:#005dae !important
}
.type-event{
    background-color:#005dae !important;
    width: 13px;
    height: 13px;
}
.type-task{
    background-color:#be4e1b !important;
    width: 13px;
    height: 13px;
}
.type-meeting{
    background-color:#be0a94!important;
    width: 13px;
    height: 13px;
}
.type-follow{
    background-color:#6774d5 !important;
    width: 13px;
    height: 13px;
}
.text-css{
    word-wrap:break-word !important
}
.text-name-ellipsis{
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 180px;
    width: 180px;
    white-space: nowrap;
}
.card-div-height{
    height:310px !important;
}
.card-follow-height{
    height:377px !important;
}
.counts{
    padding: 18px 18px 18px 18px;
    border-radius: 6px;
    min-height: 100%;
}
.div-height {
    min-height: 200px!important;
    max-height: 200px !important;
    height: 200px !important;
}
.contracts-count{
    height: 58px;
}
.card-item{
    padding: 18px 18px 30px 18px;
    border-radius: 6px;
    min-height: 100%;
}

.ml-32px{
    margin-left: 32px;
}
.deals{
    min-height: 377px;
    border-radius: 6px;
}
.pipelineDiv {
    width: 100%;
    height: 420px;
}
.pipelineDiv-expand{
    width: 100%;
    height: 500px !important;
    margin: auto;
    vertical-align: middle;
    line-height:90
}
.salesRevenueDiv-expand {
    width: 100%;
    height: 500px !important;
    margin: auto;
    vertical-align: middle;
    line-height:90;
}
.dealsDiv{
    width: 100%;
    height: 360px;
}

#legenddiv {
    height: 80px;
    width: 90%;
    position: absolute;
    bottom: 20px;
}
.logo-image{
    width: 46px;
    height: 55px;
}
.data-image{
    width: 35%;
    height: 35%;
}
.data-buiness-image{
    width: 20%;
    height: 20%;
}
.data-survey-image{
    width: 30%;
    height: 30%;
}
.contracts-logo{
    position: relative;
    bottom: 20px;
}
.pb-10px{
    padding-bottom: 10px;
}
.ongoing-survey-logo-image{
    width: 40px;
    height: 55px;
}
.survey-logo-image{
    width: 50px;
    height: 55px;
}
.meetings{
    border: 1px solid #005dae;
    border-radius: 4px;
    padding-top: 8px;
}
#targetachievedDiv {
  width: 100%;
  height: 372px;
}
.targetachievedDiv-expand{
    width: 100%;
    height: 500px !important;
    margin: auto;
    vertical-align: middle;
    line-height:90
}
#selectordiv{
    display: none;
}
#salesRevenueDiv{
  width: 100%;
  height: 322px;
}
.invitee-details{
    border: 1px solid #000;
    border-radius: 4px;
    padding:4px 5px;
    max-height:160px;
    overflow-x:scroll !important;
    width:230px;

}
.invitee-details-follow{
    /* border: 1px solid #000;
    border-radius: 4px; */
    padding:4px 0px;
    max-height:155px;
    overflow-x:scroll !important;
}
.call-details{
    border: 1px solid #005dae;
    border-radius: 4px;
}
.icon-images{
    width: 24px;
    padding-right: 10px;
}
.copy-icon-images{
    width: 30px;
}
.call-sch{
    cursor: pointer;
    font-size: 14px;
}
#days{
    cursor: not-allowed;
}
.expand-img{
    width: 20px;
    margin-bottom: 2px;
}
.today-meetings{
    min-height: 430px;
    max-height: 430px;
    overflow: auto;
}
.active:hover{
    background-color: #005dae;
    color: #fff;
}
.border-radius-6px{
    border-radius: 6px;
}
.disableButtons.fullscreen .btnpointer {
    cursor: not-allowed !important;
    display: none;
}
.disable-state{
    pointer-events: none;
    cursor: not-allowed !important;
}
.not-allow-state{
    cursor: not-allowed !important;
}
.meeting-calendar .vc-container{
    border: none;
}
.type-select{
    border: 1px solid #000;
    border-radius: 4px;
}
.btn-new-white {
    color: #000;
    background-color: #fff;
    border-bottom: 1px solid #000;
    border-radius: 0px !important;
    text-transform: capitalize !important;
    height: 34px !important;
}
.btn-new-white:focus{
    border: 1px solid #5587C7;
    border-radius: 6px !important;
}
.reminder-dropdown-menu{
    left: -28px !important;
}
.cycle-dropdown-menu{
    left: -20px !important;
}
.btn-light.btnLight {
    border: 1px solid #5587C7 !important;
    text-transform: capitalize !important;
    background-color: #FFF !important;
}
.btn-light.btnLight:hover {
    color: #212529 !important;
    background-color: #e1e7ee6b !important;
    border-color: #5587C7 !important;
}
@media only screen and(min-width: 571px) and (max-width: 3000px){
}
@media only screen and(max-width: 570px){
    .pipelineDiv{
        display: none;
    }
    .pipelineDiv-expand{
        display: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/HomeDashboard.vue